import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';
import {
  APP_MENU_TOGGLE,
  APP_NAVIGATION_TOGGLE,
} from '../../../../app/redux/actions';

import {
  NavBarContainer,
  LogoWrapper,
  FirstNav,
  SecondNav,
  IconWrapperLogin,
  LoginWrapper,
} from './style';

import { Logo, MenuButton } from '../../../atoms';
import routes from '../../../../routes';
import compose from '../../../../utils/compose';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import Icon from '../../../atoms/Icon';

const NavBarMobile = ({
  isLogged,
  menuToggle,
  navigationMobileToogle,
  menuLogo,
}) => {
  const navigate = useNavigate();

  const changeLocation = (url) => {
    menuToggle();
    navigate(url);
  };

  return (
    <NavBarContainer>
      <FirstNav>
        <LogoWrapper>
          <Logo size={Logo.SIZE.SMALL} defaultLogo />
        </LogoWrapper>
        <LoginWrapper
          onClick={() =>
            navigate(isLogged ? routes.home.path : routes.auth.path)
          }
        >
          <IconWrapperLogin>
            <Icon
              type="arrow-circle-broken-left"
              size={20}
              rotate={180}
              fill="none"
            />
          </IconWrapperLogin>
        </LoginWrapper>
      </FirstNav>
      <SecondNav>
        <LogoWrapper>
          <Logo
            size={Logo.SIZE.SMALL}
            onClick={() => changeLocation(routes.public.path)}
            src={menuLogo?.src}
            alt={menuLogo?.alt}
          />
        </LogoWrapper>
        <MenuButton handleOnClick={navigationMobileToogle} />
      </SecondNav>
    </NavBarContainer>
  );
};

NavBarMobile.propTypes = {
  isLogged: PropTypes.bool,
  // HOC withMediaQueries

  // HOC (connect, state)
  menuLogo: PropTypes.object,

  // HOC (connect, dispatch)
  menuToggle: PropTypes.func.isRequired,
  navigationMobileToogle: PropTypes.func.isRequired,
};

const composed = compose(
  connect(
    (state) => ({
      menuLogo: state.publicSite?.menuLogo,
    }),
    (dispatch) => ({
      menuToggle: () => dispatch({ type: APP_MENU_TOGGLE }),
      navigationMobileToogle: () => dispatch({ type: APP_NAVIGATION_TOGGLE }),
    })
  ),
  withMediaQueries
)(NavBarMobile);
export default composed;
